import React from 'react';
import { motion } from 'framer-motion';
import { Check, Download, Shield, Gift, Eye, Hand, Mail, Headphones } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PurchaseSection() {
  const features = ['Acceso inmediato tras la compra', 'Formato digital descargable (PDF)', 'Compatible con todos los dispositivos', 'Garantía de satisfacción 30 días'];
  const microgestures = [{
    icon: Eye,
    text: 'Una mirada suave'
  }, {
    icon: Hand,
    text: 'Un toque sin expectativas'
  }, {
    icon: Mail,
    text: 'Una nota breve'
  }, {
    icon: Headphones,
    text: 'Un momento en silencio juntos'
  }];
  return <section id="purchase-section" className="py-8 md:py-12 bg-gradient-to-b from-white to-[#faf8f6] scroll-mt-20" data-id="element-114">
      <div className="max-w-6xl mx-auto px-6" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-116">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#2d2d2d] mb-4" data-id="element-117">
            Comienza Tu Transformación Hoy
          </h2>
          <p className="text-lg md:text-xl text-[#5a5a5a] max-w-2xl mx-auto" data-id="element-118">
            Descarga inmediata. Empieza a reconectar con tu esposo desde hoy
            mismo.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-12" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="relative" data-id="element-120">
            <div className="relative z-10" data-id="element-121">
              <img src="https://cdn.magicpatterns.com/uploads/ov3p2HwiasmdJmV66Uy3et/MOCKUP_DIVORCIO_EMOCIONAL.png" alt="El Divorcio Emocional en múltiples dispositivos" className="w-full h-auto" data-id="element-122" />
            </div>
            {/* Decorative background */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[90%] bg-[#9d4b6b]/5 rounded-full blur-3xl -z-10" data-id="element-123" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl shadow-[#9d4b6b]/10 border border-[#d4a5a5]/20" data-id="element-124">
            <div className="mb-8" data-id="element-125">
              <div className="flex items-baseline gap-2 mb-2" data-id="element-126">
                <span className="text-5xl md:text-6xl font-bold text-[#9d4b6b]" data-id="element-127">
                  $12.99
                </span>
                <span className="text-xl text-[#8b6f6f] line-through" data-id="element-128">
                  $29.99
                </span>
              </div>
              <p className="text-[#5a5a5a] flex items-center gap-2" data-id="element-129">
                <Shield className="w-4 h-4 text-[#9d4b6b]" data-id="element-130" />
                Oferta especial por tiempo limitado
              </p>
            </div>

            <ul className="space-y-4 mb-8" data-id="element-131">
              {features.map((feature, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5 + index * 0.1
            }} className="flex items-start gap-3 text-[#5a5a5a]" data-id="element-132">
                  <div className="mt-1 min-w-[20px]" data-id="element-133">
                    <Check className="w-5 h-5 text-[#9d4b6b]" data-id="element-134" />
                  </div>
                  <span data-id="element-135">{feature}</span>
                </motion.li>)}
            </ul>

            <CTAButton fullWidth className="mb-4" data-id="element-136">
              <Download className="w-5 h-5" data-id="element-137" />
              Obtener Acceso Ahora
            </CTAButton>

            <p className="text-center text-sm text-[#8b6f6f] italic" data-id="element-138">
              Pago seguro • Descarga instantánea
            </p>
          </motion.div>
        </div>

        {/* Bonus Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="bg-gradient-to-br from-[#9d4b6b] to-[#8b6f6f] p-1 rounded-3xl" data-id="element-139">
          <div className="bg-white rounded-3xl p-8 md:p-10" data-id="element-140">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-141">
              <Gift className="w-8 h-8 text-[#9d4b6b]" data-id="element-142" />
              <h3 className="text-2xl md:text-3xl font-serif text-[#9d4b6b] text-center" data-id="element-143">
                BONUS ESPECIAL GRATIS
              </h3>
            </div>

            <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="element-144">
              <div className="order-2 lg:order-1" data-id="element-145">
                <h4 className="text-xl md:text-2xl font-serif text-[#2d2d2d] mb-4" data-id="element-146">
                  "Microgestos Femeninos Que Reviven la Intimidad"
                </h4>
                <p className="text-[#5a5a5a] mb-4 leading-relaxed" data-id="element-147">
                  Guía práctica de 7 días para reconectar sin confrontación ni
                  presión.
                </p>
                <p className="text-[#5a5a5a] mb-6 leading-relaxed" data-id="element-148">
                  ¿Te cuesta acercarte a tu pareja sin que se cierre o se aleje?
                  Esta guía de 7 días te muestra cómo reactivar la complicidad
                  con gestos simples, sutiles y profundamente efectivos.
                </p>

                <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-149">
                  {microgestures.map((gesture, index) => <motion.div key={index} initial={{
                  opacity: 0,
                  scale: 0.9
                }} whileInView={{
                  opacity: 1,
                  scale: 1
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.7 + index * 0.1
                }} className="flex items-center gap-2 text-[#5a5a5a]" data-id="element-150">
                      <gesture.icon className="w-5 h-5 text-[#9d4b6b] flex-shrink-0" data-id="element-151" />
                      <span className="text-sm" data-id="element-152">{gesture.text}</span>
                    </motion.div>)}
                </div>

                <p className="text-[#5a5a5a] mb-6 leading-relaxed italic text-sm" data-id="element-153">
                  No necesitas decirle que estás siguiendo una guía. Solo aplica
                  cada gesto desde tu autenticidad… y observa cómo la conexión
                  empieza a despertar.
                </p>

                <div className="bg-[#faf8f6] p-4 rounded-xl border-l-4 border-[#9d4b6b] mb-6" data-id="element-154">
                  <p className="text-sm text-[#8b6f6f] font-medium mb-2" data-id="element-155">
                    💬 Ideal si piensas:
                  </p>
                  <ul className="space-y-2 text-[#5a5a5a] text-sm" data-id="element-156">
                    <li data-id="element-157">"No sé cómo volver a acercarme sin que se aleje."</li>
                    <li data-id="element-158">
                      "No quiero hablar mucho, solo sentirnos bien otra vez."
                    </li>
                  </ul>
                </div>

                <CTAButton fullWidth data-id="element-159">
                  <Download className="w-5 h-5" data-id="element-160" />
                  Obtener Guía + Bonus Gratis
                </CTAButton>
              </div>

              <div className="order-1 lg:order-2 relative" data-id="element-161">
                <div className="relative z-10" data-id="element-162">
                  <img src="https://cdn.magicpatterns.com/uploads/iNaK5kVXHwb59naDv1YwvL/Cover_Bono_1.png" alt="Microgestos Femeninos Que Reviven la Intimidad - Bonus gratuito" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-163" />
                </div>
                {/* Decorative glow */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#9d4b6b]/20 rounded-full blur-3xl -z-10" data-id="element-164" />
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}